import { Box, Chip, Paper, Stack, Typography } from '@mui/material';
import { QmRecord } from '../../api/qmCrud';

type QmWave2ContextPanelProps = {
  qm: QmRecord;
  sectionCardSx?: Record<string, unknown>;
  title?: string;
};

function displayValue(value: string | number | null | undefined): string {
  const normalized = String(value ?? '').trim();
  return normalized || '-';
}

export default function QmWave2ContextPanel({ qm, sectionCardSx, title = 'Wave 2 Context' }: QmWave2ContextPanelProps) {
  const hasPoLines = (qm.poLines || []).length > 0;
  const hasPackages = (qm.packages || []).length > 0;
  const contextItems = [
    { label: 'Trip', value: displayValue(qm.tripReference) },
    { label: 'Manifest ID', value: displayValue(qm.manifestId) },
    { label: 'SSCC', value: displayValue(qm.sscc) },
    { label: 'ASN', value: displayValue(qm.asn) },
    { label: 'PO Line ID', value: displayValue(qm.poLineId) },
    { label: 'Item ID', value: displayValue(qm.itemId) }
  ];

  return (
    <Paper variant="outlined" sx={sectionCardSx ?? { p: 1.5 }}>
      <Stack spacing={1.1}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
          <Typography variant="subtitle2">{title}</Typography>
          <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap justifyContent="flex-end">
            {hasPoLines ? <Chip size="small" label={`${qm.poLines.length} ASN lines`} variant="outlined" /> : null}
            {hasPackages ? <Chip size="small" label={`${qm.packages.length} packages`} variant="outlined" /> : null}
          </Stack>
        </Stack>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(3, 1fr)' },
            gap: 0.75
          }}>
          {contextItems.map((item) => (
            <Box
              key={item.label}
              sx={{
                px: 1,
                py: 0.75,
                borderRadius: 1,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.default',
                minWidth: 0
              }}>
              <Typography sx={{ fontSize: '0.66rem', fontWeight: 700, color: 'text.secondary', mb: 0.2 }}>
                {item.label}
              </Typography>
              <Typography sx={{ fontSize: '0.8rem', lineHeight: 1.25, overflowWrap: 'anywhere' }}>
                {item.value}
              </Typography>
            </Box>
          ))}
        </Box>
      </Stack>
    </Paper>
  );
}
